// Mixin for text truncation
@mixin text-truncate($width: 260px) {
    width: $width;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.ux-w-my-machines {
    display: block;

    .ux-w-wrapper__body {
        > div {
            display: flex;
        }
    }

    &__item {
        display: inline-flex;
        width: 305px;
        min-width: 305px;
        max-width: 305px;
        margin-right: 2px;

        &.ux-tile {
            box-shadow: none;
            display: flex;
            flex-direction: column;
        }

        &:nth-child(even) {
            background: $color-blue-menu-bg;
        }
    }

    .ux-tile-head {
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start;
        padding: 15px 30px;
        background-color: transparent;
        height: 108px;

        &__title {
            @include text-truncate();
        }

        &__machine-name {
            color: $color-grey-3;
            @include text-truncate();
        }
    }

    .ux-tile-body {
        flex-grow: 1;
        overflow: hidden;
    }
}
